import * as React from 'react'
import { SVGProps, Ref, forwardRef, memo } from 'react'

const SvgBankCard = (
  props: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    width="1em"
    height="1em"
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
    ref={ref}
    {...props}
  >
    <g fill="currentColor" fillRule="nonzero">
      <path d="M22 3a1 1 0 0 1 .993.883L23 4v5a1 1 0 0 1-1.993.117L21 9V5H3v4a1 1 0 0 1-.883.993L2 10a1 1 0 0 1-.993-.883L1 9V4a1 1 0 0 1 .883-.993L2 3h20Z" />
      <path d="M22 8H2a1 1 0 0 0-1 1v11a1 1 0 0 0 1 1h20a1 1 0 0 0 1-1V9a1 1 0 0 0-1-1Zm-1 2v9H3v-9h18Z" />
      <path d="M7 13.5a1 1 0 0 1 .117 1.993L7 15.5H6a1 1 0 0 1-.117-1.993L6 13.5h1ZM11 13.5a1 1 0 0 1 .117 1.993L11 15.5h-1a1 1 0 0 1-.117-1.993L10 13.5h1ZM15 13.5a1 1 0 0 1 .117 1.993L15 15.5h-1a1 1 0 0 1-.117-1.993L14 13.5h1Z" />
    </g>
  </svg>
)

const ForwardRef = forwardRef(SvgBankCard)
const Memo = memo(ForwardRef)
export default Memo
